import { FunctionComponent } from "react"
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import { CartStructure } from "../../interfaces/SaleorTypes"
import { StripeAppPayment, StripePluginPayment } from "./CheckoutStripePayment"
import { Container } from "react-grid-system"
import { HorizontalSpacer } from "../../atoms/spacers"
import { STRIPE_PUBLIC_KEY } from "../../.."

interface CommonStripeWidgetProps {
  cart: CartStructure[]
  clientSecret: string
  checkoutId: string
  onClearCart: () => void
}

interface StripeAppPaymentProps extends CommonStripeWidgetProps {
  transactionId: string
}

const CommonStripeWidget: FunctionComponent<CommonStripeWidgetProps & { transactionId?: string }> = ({
  cart,
  onClearCart,
  clientSecret,
  checkoutId,
  transactionId,
}) => {
  const stripePromise = loadStripe(STRIPE_PUBLIC_KEY)

  const options = {
    clientSecret: clientSecret,
    // Fully customizable with appearance API.
    appearance: {
      variables: {
        fontFamily: ' "Karla", sans-serif',
        fontLineHeight: "1.5",
        colorBackground: "#FFFFFF",
        colorPrimaryText: "#262626",
      },
      rules: {
        ".Block": {
          boxShadow: "none",
          border: "none",
          padding: "12px",
        },
        ".Input": {
          boxShadow: "none",
          padding: "12px",
          border: "2px solid #616161",
          borderTop: "0px",
          borderRight: "0px",
          borderLeft: "0px",
          borderRadius: "0px",
        },
        ".Input:focus": {
          outline: "none",
          border: "2px solid #616161",
          borderTop: "0px",
          borderRight: "0px",
          borderLeft: "0px",
          boxShadow: "none",
        },
        ".Input:disabled, .Input--invalid:disabled": {
          color: "lightgray",
        },
        ".Tab": {
          padding: "10px 12px 8px 12px",
          border: "none",
        },
        ".Tab:hover": {
          border: "none",
          boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)",
        },
        ".Tab--selected, .Tab--selected:focus, .Tab--selected:hover": {
          border: "none",
          backgroundColor: "#fff",
          boxShadow:
            "0 0 0 1.5px var(--colorPrimaryText), 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)",
        },
        ".Label": {
          fontWeight: "500",
        },
      },
    },
  }

  return (
    <Container>
      <HorizontalSpacer spacing={2} />
      <Elements stripe={stripePromise} options={options}>
        {!transactionId ? (
          <StripePluginPayment onClearCart={onClearCart} cart={cart} checkoutId={checkoutId} />
        ) : (
          <StripeAppPayment
            onClearCart={onClearCart}
            cart={cart}
            checkoutId={checkoutId}
            transactionId={transactionId}
          />
        )}
      </Elements>
    </Container>
  )
}

export const StripeAppWidget: FunctionComponent<StripeAppPaymentProps> = (props) => <CommonStripeWidget {...props} />
export const StripePluginWidget: FunctionComponent<CommonStripeWidgetProps> = (props) => (
  <CommonStripeWidget {...props} />
)
